export default defineNuxtPlugin(() => {
  // Only load Klaviyo on client-side
  if (import.meta.client) {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadKlaviyo)
    } else {
      loadKlaviyo()
    }
  }

  function loadKlaviyo() {
    // Check if Klaviyo is already loaded
    if (window._learnq) {
      return
    }

    // Create script element
    const script = document.createElement('script')
    script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=XXthe2'
    script.async = true
    script.defer = true
    
    // Add error handling
    script.onerror = () => {
      console.warn('Klaviyo script failed to load')
      // Hide any Klaviyo forms that might have been created
      const klaviyoForms = document.querySelectorAll('[class*="klaviyo-form"]')
      klaviyoForms.forEach(form => {
        if (form instanceof HTMLElement) {
          form.style.display = 'none'
        }
      })
    }

    // Add success handler
    script.onload = () => {
      console.log('Klaviyo script loaded successfully')
    }

    document.head.appendChild(script)
  }
})
